<!-- eslint-disable max-len -->
<template>
  <div class="char-tree-root">
    <template v-if="loading">
      <div v-if="loading" style="display: flex; justify-content: center; align-items: center; width: 100%; height: 300px;">
        <blade-spinner no-background/><div style="margin-left: 10px; font-size: 20px;">Loading...</div>
      </div>
    </template>
    <template v-else>
      <div v-if="false" style="width: 100; background-color: #dddddd; max-height: 100px; overflow-y: auto; padding: 10px;">
        <h4>debug</h4>
        <div>{{currentWorkingDirectory}}</div>
        <div>{{currentPathParts}}</div>
        <div>{{currentNode}}</div>
      </div>
      <div class="character-filter-container">
        <!-- First item doesn't need a margin -->
        <div class="character-filter-item" style="margin-left: 0px;">
          <text-input class="remove-bottom-margin" v-model="filters.filterString">
            Search
          </text-input>
          <checkbox-input class="remove-bottom-margin" v-model="filters.advancedSearch">
            Advanced Search <i style="margin-left: 10px;" class="fas fa-question-circle" v-b-tooltip.hover title="Comma-separated search string.  Allows for eg, 'nurse, female'." />
          </checkbox-input>
        </div>
        <template v-if="!hideCharacters">
          <div class="character-filter-item">
            <select-input
              class="remove-bottom-margin"
              v-model="filters.theme"
              :options="themeOptions"
              :display="o => ((o === 'starfighter') ? 'panoramic' : o)"
            >
              Theme
            </select-input>
            <checkbox-input v-if="root === '/' && !hideCharacters" class="remove-bottom-margin" v-model="filters.flatList">
              Flat Character List <i style="margin-left: 10px;" class="fas fa-question-circle" v-b-tooltip.hover title="Replaces the directory tree with a flat list of characters" />
            </checkbox-input>
          </div>
          <div class="character-filter-item">
            <checkbox-input class="remove-bottom-margin" v-model="filters.avatar">
              Avatar
            </checkbox-input>
            <checkbox-input class="remove-bottom-margin" v-model="filters.challengeIntro">
              Section Intro
            </checkbox-input>
          </div>
          <div class="character-filter-item">
            <checkbox-input class="remove-bottom-margin" v-model="filters.narrator">
              Narrator
            </checkbox-input>
            <checkbox-input class="remove-bottom-margin" v-model="filters.scrollImage">
              Scroll Image
            </checkbox-input>
          </div>
          <div class="character-filter-item">
            <checkbox-input class="remove-bottom-margin" v-model="filters.twoDimensional">
              2D
            </checkbox-input>
          </div>
        </template>
      </div>
      <b-breadcrumb v-if="!filters.flatList" style="margin-top: 10px;">
        <b-breadcrumb-item @click="changeDirectory(root)" :disabled="currentPathParts.length === 0" :active="currentPathParts.length === 0">Root</b-breadcrumb-item>
        <template v-for="(item, idx) of currentPathParts">
          <b-breadcrumb-item @click="changeDirectoryFromBreadcrumbIndex(idx)" :disabled="currentPathParts.length - 1 == idx" :active="currentPathParts.length - 1 == idx" :key="idx">{{item}}</b-breadcrumb-item>
        </template>
      </b-breadcrumb>
      <template v-if="allowEditing">
        <div style="display: flex; margin-top: 10px;" v-if="!filters.flatList">
          <b-btn @click="clickCreateFolder()">Create Folder</b-btn>
          <!-- <b-btn @click="clickAddCharacter()" style="margin-left: 10px;">Add Character</b-btn> -->
        </div>

        <b-modal ref="createModal" :title="createModalTitle" size="lg" centered @ok="clickCreate">
          <template v-if="createMode === 0">
            <!-- Folder -->
            <text-input
              label
              v-model="createModalData.name"
            >
              Name
            </text-input>
          </template>
          <template v-if="createMode === 1">
            <!-- Character -->
            <text-input
              label
              v-model="createModalData.name"
            >
              Name (defaults to character title if blank)
            </text-input>

            <!-- TODO: Character selector -->
          </template>
        </b-modal>

        <b-modal ref="addAliasModal" :title="aliasModalData.title" size="lg" centered @ok="createAlias" @hidden="resetAliasModal">
          <text-input class="remove-bottom-margin" v-model="aliasModalData.fileName">
            Alias Name
          </text-input>
          <character-select-input v-model="aliasModalData.parentPath" label hide-characters select-folder :root="root" :start-path="startPath">
            Target Directory
          </character-select-input>
        </b-modal>
      </template>
      <template v-if="currentNode">
        <template v-for="(item, idx) of filteredChildren">
          <template v-if="(!hideCharacters || !item.character) || (filters.flatList && item.character)">
            <div v-if="item.isFirstUnsorted && !filters.flatList" :key="`${item.path || item.character._id}-idx-divider`">
              <hr/>
              <h5>Uncategorized (only visible at the root)</h5>
            </div>
            <div @click.stop="clickListItem(item)" :class="item.character && item.character._id === selectedId ? 'file-entry-selected' : 'file-entry'" :key="`${item.path}-${idx}`">
              <div class="file-entry-content">
                <div style="display: flex; flex-direction: row; align-items: center;">
                  <!-- <i style="margin-right: 10px;" :class="`fas fa-${item.character ? 'user' : 'folder'}`"/> -->
                  <div style="margin-right: 10px;">
                    <img
                      v-if="item.character"
                      class="child-character-icon"
                      :src="resolveAssetPath(item.character.icon || item.character.iconDecided || item.character.iconUndecided, 'characters')"
                    />
                    <i
                      v-else
                      class="fas fa-folder"
                    />
                  </div>
                  <div>
                    <div v-if="item.localPath">{{item.localPath}}</div>
                    <!-- <div v-else style="font-size: 13px;">(Unsorted)</div> -->
                    <div v-if="item.character" style="font-size: 13px;">
                      <div>
                        <span v-if="item.character.isOldCharacter" style="color: red; font-weight: bold;">[NON-CENTRALIZED]</span>
                        {{item.character.name}} ({{item.character.title}})
                      </div>
                      <div>
                        Last Edited on {{item.character.updated.toLocaleString()}}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="file-entry-edit-buttons">
                  <div v-if="item.character && item.character._id === selectedId" style="font-style: italic;">
                    SELECTED
                  </div>

                  <template v-if="!item.character">
                    <b-btn v-if="selectFolder" class="file-entry-buttons" @click.stop="$emit('directory-selected', item)">Select</b-btn>
                  </template>

                  <template v-if="allowEditing">
                    <template v-if="item.localPath">
                      <b-btn v-if="item.character" class="file-entry-buttons" @click.stop="clickAddAlias(item)">Add Alias</b-btn>
                      <!-- <b-btn class="file-entry-buttons" @click.stop="renameNode(item)">Rename</b-btn> -->
                      <b-btn class="file-entry-buttons" @click.stop="deleteNode(item)">Delete {{(item.character ? 'Alias' : 'Folder')}}</b-btn>
                    </template>
                    <template v-else>
                      <b-btn class="file-entry-buttons" @click.stop="clickAddAlias(item)">Categorize</b-btn>
                    </template>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </template>
        <b-btn v-if="selectFolder" class="file-entry-buttons" @click.stop="$emit('directory-selected', currentNode.node)">Select Current Directory ({{currentWorkingDirectory}})</b-btn>
      </template>
      <template v-else>
        Error: Path not found.
        <span v-if="currentWorkingDirectory !== root">Please return to root.</span>
        <span v-else>Please submit a bug report as this text should never appear.</span>
        <!-- <span class="span-link" @click="changeDirectory(root)">Click here to return to safety.</span> -->
      </template>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import TextInput from '../../../ui/inputs/TextInput';
import CheckboxInput from '../../../ui/inputs/CheckboxInput';
import SelectInput from '../../../ui/inputs/SelectInput';
import CharacterSelectInput from '../../../ui/inputs/CharacterSelectInput';

export default {
  name: 'character-tree-visualizer',
  components: {
    CharacterSelectInput,
    TextInput,
    CheckboxInput,
    SelectInput
  },
  props: {
    root: { type: String, default: '/' },
    startPath: { type: String, default: '/' },
    defaultFilters: { type: Object, default: () => ({}) },
    filterCallback: { type: Function, default: null },
    selectedId: String,
    hideCharacters: Boolean,
    allowEditing: Boolean,
    selectFolder: Boolean,
  },
  data() {
    return {
      aliasModalData: {
        title: '',
        parentPath: '/',
        fileName: '',
        target: null
      },
      createModalData: {
        name: '',
      },
      filters: {
        avatar: false,
        narrator: false,
        challengeIntro: false,
        scrollImage: false,
        twoDimensional: false,
        advancedSearch: false,
        flatList: false,
        filterString: '',
        theme: ''
      },
      characters: [],
      themeOptions: [],
      createMode: 0,
      createModalTitle: 'Create Folder',
      loading: false,
      currentWorkingDirectory: '',
      currentNode: null
    };
  },
  computed: {
    currentPathParts() {
      return this.currentWorkingDirectory.split('/').filter(a => a !== '');
    },
    children() {
      let res;
      if (this.filters.flatList) {
        res = this.characters.map(a => ({ character: a }));
      } else {
        res = this.currentNode.children;
        if (this.currentNode === null) {
          return [];
        }
      }

      // Needs to handle `/` differently than `/asdfasfd`
      const len = this.currentWorkingDirectory.length > 1
        ? this.currentWorkingDirectory.length + 1
        : this.currentWorkingDirectory.length;

      return res.map((a) => {
        if (a.path) {
          a.localPath = a.path.substring(len);
        }
        return a;
      }).sort((a, b) => {
        if (a.character && a.character._id === this.selectedId) {
          return -1;
        }
        if (b.character && b.character._id === this.selectedId) {
          return 1;
        }

        if (a.character && !b.character) {
          return 1;
        }
        if (b.character && !a.character) {
          return -1;
        }

        // Old characters only show up in the flat list, but we want them to
        // be after centralized characters.
        if (a.character && b.character
            && a.character.isOldCharacter !== b.character.isOldCharacter) {
          if (a.character.isOldCharacter) return 1;
          if (b.character.isOldCharacter) return -1;
        }

        // Path can only be null for unsorted characters.
        if (a.path && b.path) {
          return a.path.localeCompare(b.path);
        }
        if (a.path) return -1;
        if (b.path) return 1;
        return a.character.name.localeCompare(b.character.name);
      });
    },
    filteredChildren() {
      let textFilter = this.filters.filterString.trim().toLowerCase();
      const useAdvancedSearch = this.filters.advancedSearch;
      const explodedFilter = textFilter.split(',').map(a => a.trim()).filter(a => a && a.length > 0);

      if (textFilter.length === 0) textFilter = null;

      console.log(this.children);

      let hasFoundUnsorted = false;
      // First filter
      const unfiltered = this.children;
      const filtered = unfiltered.filter((item) => {
        if (item.character) {
          if (this.filterCallback && !this.filterCallback(item.character)) {
            return false;
          }
          if (textFilter) {
            if (useAdvancedSearch) {
              let found = true;
              // eslint-disable-next-line no-restricted-syntax
              for (const filter of explodedFilter) {
                found = found && (item.character.name.toLowerCase().includes(filter)
                  || item.character.title.toLowerCase().includes(filter)
                  || (item.localPath && item.localPath.toLowerCase().includes(filter)));
                if (!found) break;
              }
              if (!found) {
                return false;
              }
            } else if (!(
              item.character.name.toLowerCase().includes(textFilter)
              || item.character.title.toLowerCase().includes(textFilter)
              || (item.localPath && item.localPath.toLowerCase().includes(textFilter))
            )) {
              return false;
            }
          }
          if (this.filters.avatar && !item.character.avatar) {
            return false;
          }
          if (this.filters.narrator && !item.character.narrator) {
            return false;
          }
          if (this.filters.challengeIntro && !item.character.challengeIntro) {
            return false;
          }
          if (this.filters.scrollImage && !item.character.scrollImage) {
            return false;
          }
          if (this.filters.twoDimensional && !item.character.twoDimensional) {
            return false;
          }
          if (this.filters.twoDimensional && !item.character.twoDimensional) {
            return false;
          }

          const theme = this.filters.theme;
          if (theme !== null && theme !== '' && theme !== 'any') {
            if (item.character.theme !== 'any' && item.character.theme !== theme) {
              return false;
            }
          }
        } else if (textFilter) {
          if (useAdvancedSearch) {
            let found = true;
            // eslint-disable-next-line no-restricted-syntax
            for (const filter of explodedFilter) {
              found = found && item.localPath.toLowerCase().includes(filter);
              if (!found) break;
            }
            if (!found) {
              return false;
            }
          } else if (!item.localPath.toLowerCase().includes(textFilter)) {
            return false;
          }
        }

        return true;
      }).map((a) => {
        // Then handle the first unsorted element
        if (!a.path && !hasFoundUnsorted) {
          hasFoundUnsorted = true;
          a.isFirstUnsorted = true;
        } else {
          a.isFirstUnsorted = false;
        }
        return a;
      });

      return filtered;
    }
  },
  methods: {
    ...mapActions([
      'getCharacters',
      'getCharacterEnums',
      'createCharacterTreeFolder',
      'createCharacterTreeCharacterNode',
      'getCharacterTreeNode',
      'getCharacterTreeChildren',
      'deleteCharacterTreeNode'
    ]),
    async clickCreate(bvModalEvt) {
      const createName = this.createModalData.name.trim();
      if (createName.includes('/')) {
        // eslint-disable-next-line no-alert
        alert('The path must not include a /');
        bvModalEvt.preventDefault();
        return;
      }
      if (createName.trim().length === 0) {
        // eslint-disable-next-line no-alert
        alert('The path can not be empty');
        bvModalEvt.preventDefault();
        return;
      }

      if (this.createMode === 0) {
        // Folder
        await this.createCharacterTreeFolder({
          parent: this.currentNode.node,
          path: createName
        });
        this.createModalData.name = '';
      } else if (this.createMode === 1) {
        // Character
        if (!this.createModalData.characterId) {
          // eslint-disable-next-line no-alert
          alert('Please select a valid character');
          bvModalEvt.preventDefault();
          return;
        }

        await this.createCharacterTreeCharacterNode({
          parent: this.currentNode.node,
          path: this.currentWorkingDirectory,
          characterId: this.createModalData.characterId
        });
        this.createModalData.name = '';
        this.createModalData.characterId = null;
      }
      await this.refresh();
    },
    clickCreateFolder() {
      this.createModalTitle = 'Create Folder';
      this.createMode = 0;
      this.$refs.createModal.show();
    },
    clickAddCharacter() {
      this.createModalTitle = 'Add Character';
      this.createMode = 1;
      this.$refs.createModal.show();
    },
    async clickListItem(item) {
      if (item.character) {
        if (this.allowEditing) {
          this.$router.push(`/blade/characters/${item.character._id}/edit`);
        } else {
          this.$emit('character-selected', item.character);
        }
      } else {
        await this.changeDirectory(item.path);
      }
    },

    async clickAddAlias(item) {
      if (item.localPath) {
        this.aliasModalData.title = 'Add Alias';
      } else {
        this.aliasModalData.title = 'Categorize';
      }
      this.aliasModalData.target = item;
      this.$refs.addAliasModal.show();
    },
    async createAlias(bvModalEvt) {
      const fileName = this.aliasModalData.fileName.trim();
      if (fileName.length === 0) {
        // eslint-disable-next-line no-alert
        alert('Please enter a valid alias name');
        bvModalEvt.preventDefault();
        return;
      }

      if (!this.aliasModalData.target) {
        // eslint-disable-next-line no-alert
        alert('Invalid character selected.  This is a bug.  Please report this error.');
        bvModalEvt.preventDefault();
        return;
      }

      // eslint-disable-next-line no-shadow
      const parentPath = this.aliasModalData.parentPath;
      console.log({ parentPath, fileName, characterId: this.aliasModalData.target.character._id });

      try {
        await this.createCharacterTreeCharacterNode({
          parentPath,
          fileName,
          characterId: this.aliasModalData.target.character._id
        });
      } catch (err) {
        console.error(err);
        // eslint-disable-next-line no-alert
        alert('Failed to create character alias.  Please ensure there are no name conflicts.');
        bvModalEvt.preventDefault();
      }
      await this.refresh();


      // TODO: Create a new alias
      return true;
    },

    resetAliasModal() {
      this.aliasModalData.target = null;
      this.aliasModalData.parentPath = '/';
      this.aliasModalData.fileName = '';
    },

    async deleteNode(item) {
      try {
        if (item.character) {
          // eslint-disable-next-line no-alert
          if (!confirm('You are about to delete a character alias.  Continue?')) return;
        }
        await this.deleteCharacterTreeNode(item);
      } catch (err) {
        if (err && err.response && err.response.status === 428) {
          // eslint-disable-next-line no-alert
          if (confirm('You are about to delete a non-empty directory.  Continue?')) {
            await this.deleteCharacterTreeNode({ ...item, confirmMultiDelete: true });
          } else {
            return;
          }
        }
      }
      await this.refresh();
    },
    async refresh() {
      try {
        this.loading = true;
        await this.changeDirectory(this.currentWorkingDirectory, true);
      } catch (er) {
        // TODO(?): Handle error somehow?
        console.error(er);
      } finally {
        this.loading = false;
      }
    },
    async changeDirectory(path, forceRefresh = false) {
      if (path === this.currentWorkingDirectory && !forceRefresh) return;

      // TODO: Error if we try to navigate outside of the root
      if (!path.startsWith(this.root)) {
        // eslint-disable-next-line no-alert
        alert('You can\'t navigate outside of the current directory');
        return;
      }

      const targetDir = path;
      try {
        this.loading = true;
        const res = await this.getCharacterTreeChildren({ path: targetDir, forceRefresh });
        this.currentNode = res;
        this.currentWorkingDirectory = path;
      } catch (er) {
        // TODO(?): Handle error somehow?
        console.error(er);
      } finally {
        this.loading = false;
      }
    },
    async changeDirectoryFromBreadcrumbIndex(idx) {
      const path = `/${this.currentPathParts.slice(0, idx + 1).join('/')}`;
      await this.changeDirectory(path);
    },
    async loadCharacterInfo() {
      const enumWait = this.getCharacterEnums();
      const charWait = this.getCharacters();
      const { themes } = await enumWait;
      const characters = await charWait;

      this.themeOptions = themes;
      this.characters = characters;
    }
  },
  async created() {
    this.loading = true;
    const charWait = this.loadCharacterInfo();
    const providedKeys = Object.keys(this.defaultFilters);

    // eslint-disable-next-line no-restricted-syntax
    for (const key of providedKeys) {
      if (this.defaultFilters[key] === true || key === 'filterString') {
        this.$set(this.filters, key, this.defaultFilters[key]);
      }
    }

    this.currentWorkingDirectory = this.startPath || this.root;
    await charWait;
    await this.refresh();
  }
};
</script>

<style lang="scss" scoped>
.span-link
{
  // TODO
  color: red;
}

.span-link:hover
{
  transition: ease 150ms;
  // TODO
  cursor: pointer;
  color: cyan;
}

.file-entry
{
  transition: ease 150ms;
  width: 100%;
  margin: 2px;
  padding: 10px;
  background-color: hsl(210, 16%, 95%);
}

.file-entry-selected
{
  transition: ease 150ms;
  width: 100%;
  margin: 2px;
  padding: 10px;
  background-color: hsl(210, 16%, 85%);
}

.file-entry:hover
{
  transition: ease 150ms;
  cursor: pointer;
  background-color: hsl(210, 16%, 97%);
}

.file-entry-content
{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.file-entry-edit-buttons
{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
  min-height: 100%;
}

.file-entry-buttons
{
  margin-left: 5px;
  height: 32px;
}

.character-filter-container
{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #E9ECEF;
  width: 100%;
  height: 100px;
  padding: 20px;
}

.character-filter-item
{
  margin-left: 10px;
  height: 100%;
}

.remove-bottom-margin
{
  margin-bottom: 0px !important;
}

.child-character-icon
{
  background-color: #aaaaaa;
  display: block;
  object-fit: contain;
  object-position: center;
  max-width: 64px;
  max-height: 64px;
}
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/components/CharacterTreeVisualizer.vue